<template>

  <b-nav class="ml-4">
    <b-nav-item>
      <router-link :to="{ path: `/member/${memberId}/progress` }">
        <b-button
          :class="this.$route.name == 'trainingProgress' ? null : 'esep-blue-bg'"
          variant="primary"
        >{{ $t("common.training") }}
        </b-button
        >
      </router-link>
    </b-nav-item>
    <b-nav-item>
      <router-link :to="{ path: `/apply-activities/trainee/${memberId}` }">
        <b-button
          :class="this.$route.name == 'applyActivities' ? null : 'esep-blue-bg'"
          variant="primary"
        >{{ $t("message.applyActivitiesMine") }}
        </b-button
        >
      </router-link>
    </b-nav-item>
    <b-nav-item>
      <router-link :to="{ path: `/evaluations/member/${memberId}` }">
        <b-button
          :class="this.$route.name == 'evaluations' ? null : 'esep-blue-bg'"
          variant="primary"
        >{{ $t("message.evaluations") }}
        </b-button
        >
      </router-link>
    </b-nav-item>

    <b-nav-item>
      <router-link :to="{ path: `/participations?memberId=${memberId}` }">
        <b-button :class="this.$route.name == 'participations' ? null : 'esep-blue-bg'" variant="primary">
          {{ $t("toolbar.participations") }}
        </b-button>
      </router-link>
    </b-nav-item>

    <b-nav-item>
      <router-link :to="{ path: `/trainings/calendar` }">
        <b-button :class="this.$route.name == 'trainingCalendar' ? null : 'esep-blue-bg'" variant="primary">{{ $t("toolbar.calendar") }}</b-button>
      </router-link>
    </b-nav-item>

    <b-nav-item>
      <router-link :to="{ path: `/trainings/apply` }">
        <b-button :class="this.$route.name == 'applications' ? null : 'esep-blue-bg'" variant="primary">{{ $t("toolbar.applications") }}</b-button>
      </router-link>
    </b-nav-item>


  </b-nav>
</template>
<script>
import trainingService from "@/services/training.service";
import {handleApiError} from "@/services/error.service";

export default {
  props: {
    forcedMemberId: {
      type: Number
    },
  },
  name: 'training-member-toolbar',
  data() {
    return {
      isAdmin: false,
      isTrainingAdmin: false,
      isTrainingMod: false,
      isUnitAdmin: false,
      userInfo: {},
      orgMember: {}
    }
  },
  computed: {
    memberId() {
      return this.forcedMemberId || this.$route.params?.id || this.$store.state.userInfo?.orgMember?.id;
    },
  },
  methods: {
    fetchRoles() {
      trainingService.getUserInfo(this.username).then(
          (response) => {
            this.userInfo = response.data;
            this.$store.state.userInfo = this.userInfo;
            trainingService.getMemberById(this.memberId).then(
                (response) => {
                  this.orgMember = response.data;
                }
            );

            for(var i=0; i< this.userInfo.roles.length; i++){
              if(this.userInfo.roles[i].name == "ADMIN" ) {
                this.isAdmin = true;
              } else if(this.userInfo.roles[i].name == "TRAINING_ADMIN") {
                this.isTrainingAdmin = true;
              } else if(this.userInfo.roles[i].name == "TRAIN_MOD"){
                this.isTrainingMod = true;
              } else if(this.userInfo.roles[i].name == "UNIT_ADMIN"){
                this.isUnitAdmin = true;
              }
            }

          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.handleError(errorMessage);
          }
      );



    }
  },
  mounted() {
    this.fetchRoles();
  },
}
</script>